export default "__VITE_ASSET__9143f51c__"